import { render } from "./CookiesSortingTH.vue?vue&type=template&id=3da133e7"
import script from "./CookiesSortingTH.vue?vue&type=script&lang=js"
export * from "./CookiesSortingTH.vue?vue&type=script&lang=js"

import "./CookiesSortingTH.vue?vue&type=style&index=0&id=3da133e7&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__